import React, { useState, useRef, useEffect } from 'react';
import { MapPin } from 'lucide-react';

// Popular cities with Chinese and English names
const CITY_LIST = [
    // China - Tier 1
    { cn: '北京', en: 'Beijing', pinyin: 'beijing' },
    { cn: '上海', en: 'Shanghai', pinyin: 'shanghai' },
    { cn: '广州', en: 'Guangzhou', pinyin: 'guangzhou' },
    { cn: '深圳', en: 'Shenzhen', pinyin: 'shenzhen' },
    // China - New Tier 1
    { cn: '成都', en: 'Chengdu', pinyin: 'chengdu' },
    { cn: '杭州', en: 'Hangzhou', pinyin: 'hangzhou' },
    { cn: '重庆', en: 'Chongqing', pinyin: 'chongqing' },
    { cn: '武汉', en: 'Wuhan', pinyin: 'wuhan' },
    { cn: '西安', en: "Xi'an", pinyin: 'xian' },
    { cn: '苏州', en: 'Suzhou', pinyin: 'suzhou' },
    { cn: '天津', en: 'Tianjin', pinyin: 'tianjin' },
    { cn: '南京', en: 'Nanjing', pinyin: 'nanjing' },
    { cn: '长沙', en: 'Changsha', pinyin: 'changsha' },
    { cn: '郑州', en: 'Zhengzhou', pinyin: 'zhengzhou' },
    { cn: '青岛', en: 'Qingdao', pinyin: 'qingdao' },
    { cn: '东莞', en: 'Dongguan', pinyin: 'dongguan' },
    { cn: '沈阳', en: 'Shenyang', pinyin: 'shenyang' },
    { cn: '宁波', en: 'Ningbo', pinyin: 'ningbo' },
    { cn: '合肥', en: 'Hefei', pinyin: 'hefei' },
    { cn: '佛山', en: 'Foshan', pinyin: 'foshan' },
    // China - Tier 2
    { cn: '厦门', en: 'Xiamen', pinyin: 'xiamen' },
    { cn: '大连', en: 'Dalian', pinyin: 'dalian' },
    { cn: '福州', en: 'Fuzhou', pinyin: 'fuzhou' },
    { cn: '济南', en: 'Jinan', pinyin: 'jinan' },
    { cn: '昆明', en: 'Kunming', pinyin: 'kunming' },
    { cn: '无锡', en: 'Wuxi', pinyin: 'wuxi' },
    { cn: '南宁', en: 'Nanning', pinyin: 'nanning' },
    { cn: '南昌', en: 'Nanchang', pinyin: 'nanchang' },
    { cn: '哈尔滨', en: 'Harbin', pinyin: 'haerbin' },
    { cn: '石家庄', en: 'Shijiazhuang', pinyin: 'shijiazhuang' },
    { cn: '贵阳', en: 'Guiyang', pinyin: 'guiyang' },
    { cn: '太原', en: 'Taiyuan', pinyin: 'taiyuan' },
    { cn: '珠海', en: 'Zhuhai', pinyin: 'zhuhai' },
    // Hong Kong, Macau, Taiwan
    { cn: '香港', en: 'Hong Kong', pinyin: 'xianggang' },
    { cn: '澳门', en: 'Macau', pinyin: 'aomen' },
    { cn: '台北', en: 'Taipei', pinyin: 'taibei' },
    { cn: '高雄', en: 'Kaohsiung', pinyin: 'gaoxiong' },
    // International - Asia
    { cn: '东京', en: 'Tokyo', pinyin: 'dongjing' },
    { cn: '大阪', en: 'Osaka', pinyin: 'daban' },
    { cn: '首尔', en: 'Seoul', pinyin: 'shouer' },
    { cn: '新加坡', en: 'Singapore', pinyin: 'xinjiapo' },
    { cn: '曼谷', en: 'Bangkok', pinyin: 'mangu' },
    { cn: '吉隆坡', en: 'Kuala Lumpur', pinyin: 'jilongpo' },
    { cn: '雅加达', en: 'Jakarta', pinyin: 'yajiade' },
    { cn: '马尼拉', en: 'Manila', pinyin: 'manila' },
    { cn: '河内', en: 'Hanoi', pinyin: 'henei' },
    { cn: '胡志明市', en: 'Ho Chi Minh City', pinyin: 'huzhimingshi' },
    { cn: '孟买', en: 'Mumbai', pinyin: 'mengmai' },
    { cn: '新德里', en: 'New Delhi', pinyin: 'xindeli' },
    { cn: '迪拜', en: 'Dubai', pinyin: 'dibai' },
    // International - Americas
    { cn: '纽约', en: 'New York', pinyin: 'niuyue' },
    { cn: '洛杉矶', en: 'Los Angeles', pinyin: 'luoshanji' },
    { cn: '旧金山', en: 'San Francisco', pinyin: 'jiujinshan' },
    { cn: '西雅图', en: 'Seattle', pinyin: 'xiyatu' },
    { cn: '芝加哥', en: 'Chicago', pinyin: 'zhijiage' },
    { cn: '波士顿', en: 'Boston', pinyin: 'boshidun' },
    { cn: '迈阿密', en: 'Miami', pinyin: 'maiami' },
    { cn: '华盛顿', en: 'Washington D.C.', pinyin: 'huashengdun' },
    { cn: '多伦多', en: 'Toronto', pinyin: 'duolunduo' },
    { cn: '温哥华', en: 'Vancouver', pinyin: 'wengehua' },
    { cn: '蒙特利尔', en: 'Montreal', pinyin: 'mengtelier' },
    // International - Europe
    { cn: '伦敦', en: 'London', pinyin: 'lundun' },
    { cn: '巴黎', en: 'Paris', pinyin: 'bali' },
    { cn: '柏林', en: 'Berlin', pinyin: 'bolin' },
    { cn: '慕尼黑', en: 'Munich', pinyin: 'munihei' },
    { cn: '阿姆斯特丹', en: 'Amsterdam', pinyin: 'amusitedan' },
    { cn: '罗马', en: 'Rome', pinyin: 'luoma' },
    { cn: '米兰', en: 'Milan', pinyin: 'milan' },
    { cn: '马德里', en: 'Madrid', pinyin: 'madeli' },
    { cn: '巴塞罗那', en: 'Barcelona', pinyin: 'basailuona' },
    { cn: '维也纳', en: 'Vienna', pinyin: 'weiyena' },
    { cn: '苏黎世', en: 'Zurich', pinyin: 'sulishi' },
    { cn: '日内瓦', en: 'Geneva', pinyin: 'rineiwa' },
    { cn: '斯德哥尔摩', en: 'Stockholm', pinyin: 'sidegeermo' },
    { cn: '哥本哈根', en: 'Copenhagen', pinyin: 'gebenhagen' },
    { cn: '莫斯科', en: 'Moscow', pinyin: 'mosike' },
    // International - Oceania
    { cn: '悉尼', en: 'Sydney', pinyin: 'xini' },
    { cn: '墨尔本', en: 'Melbourne', pinyin: 'moerben' },
    { cn: '奥克兰', en: 'Auckland', pinyin: 'aokelan' },
];

interface CityAutocompleteProps {
    value: string;
    onChange: (value: string) => void;
    name?: string;
    placeholder?: string;
    className?: string;
}

const CityAutocomplete: React.FC<CityAutocompleteProps> = ({
    value,
    onChange,
    name = 'location',
    placeholder = '输入城市名 (中文/英文/拼音)',
    className = ''
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [suggestions, setSuggestions] = useState<typeof CITY_LIST>([]);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const inputRef = useRef<HTMLInputElement>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);

    // Filter suggestions based on input
    useEffect(() => {
        if (!value.trim()) {
            setSuggestions([]);
            return;
        }

        const query = value.toLowerCase().trim();
        const filtered = CITY_LIST.filter(city =>
            city.cn.includes(value) ||
            city.en.toLowerCase().includes(query) ||
            city.pinyin.includes(query)
        ).slice(0, 8); // Limit to 8 suggestions

        setSuggestions(filtered);
        setHighlightedIndex(-1);
    }, [value]);

    // Handle click outside to close dropdown
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node) &&
                inputRef.current &&
                !inputRef.current.contains(event.target as Node)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
        setIsOpen(true);
    };

    const handleSelectCity = (city: typeof CITY_LIST[0]) => {
        onChange(city.cn);
        setIsOpen(false);
        setSuggestions([]);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (!isOpen || suggestions.length === 0) return;

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setHighlightedIndex(prev =>
                    prev < suggestions.length - 1 ? prev + 1 : prev
                );
                break;
            case 'ArrowUp':
                e.preventDefault();
                setHighlightedIndex(prev => prev > 0 ? prev - 1 : prev);
                break;
            case 'Enter':
                e.preventDefault();
                if (highlightedIndex >= 0 && highlightedIndex < suggestions.length) {
                    handleSelectCity(suggestions[highlightedIndex]);
                }
                break;
            case 'Escape':
                setIsOpen(false);
                break;
        }
    };

    return (
        <div className="relative">
            <input
                ref={inputRef}
                type="text"
                name={name}
                value={value}
                onChange={handleInputChange}
                onFocus={() => setIsOpen(true)}
                onKeyDown={handleKeyDown}
                placeholder={placeholder}
                autoComplete="off"
                className={`w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black transition-all ${className}`}
            />

            {/* Suggestions Dropdown */}
            {isOpen && suggestions.length > 0 && (
                <div
                    ref={dropdownRef}
                    className="absolute z-50 w-full mt-2 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden"
                    style={{ maxHeight: '300px', overflowY: 'auto' }}
                >
                    {suggestions.map((city, index) => (
                        <div
                            key={`${city.cn}-${city.en}`}
                            onClick={() => handleSelectCity(city)}
                            onMouseEnter={() => setHighlightedIndex(index)}
                            className={`flex items-center gap-3 px-4 py-3 cursor-pointer transition-colors ${index === highlightedIndex
                                ? 'bg-gray-100'
                                : 'hover:bg-gray-50'
                                }`}
                        >
                            <MapPin className="w-4 h-4 text-gray-400 flex-shrink-0" />
                            <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2">
                                    <span className="font-medium text-gray-900">{city.cn}</span>
                                    <span className="text-gray-500 text-sm">{city.en}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CityAutocomplete;
